module.exports = __webpack_public_path__ + "static/play-d61a9b62b9c83c0ca9ccd8e0340d825c.svg";